export const FIVE_SECONDS_IN_MILLI = 5 * 1000; // 5 seconds in milliseconds